import classNames from 'classnames';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * @callback onChange
 * @param {boolean} isChecked - True if the checkbox is checked, otherwise
 *    false.
 */

/**
 * A switch UI component for a single checkbox.
 *
 * @param {object} props - Props.
 * @param {string} props.id - ID.
 * @param {string} props.label - Label.
 * @param {boolean} props.isChecked - True if checkbox is checked, otherwise
 *    false.
 * @param {onChange} props.onChange - Callback function executed when the
 *    checked state of the checkbox changes.
 * @returns {JSX.Element} Component.
 */
export const SwitchInput = props => {
    const [ isChecked, setIsChecked ] = useState( props.isChecked );

    const onChange = evt => {
        const { checked } = evt.target;
        setIsChecked( checked );
        props.onChange( checked );
    };

    return (
        <div className={ classNames( 'switch-input', {
            'switch-input--checked': isChecked
        } ) }>
            <label
                className="switch-input__label"
                htmlFor={ props.id }
            >
                { props.label }

                <input
                    className="switch-input__input"
                    type="checkbox"
                    id={ props.id }
                    checked={ isChecked }
                    onChange={ onChange }
                />
            </label>
        </div>
    );
};

SwitchInput.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    isChecked: PropTypes.bool,
    onChange: PropTypes.func
};